import { createInitialEntities } from "../../utils/createInitialEntities";
import { TAppMenu, TAppMenus, TMenuIds } from "../types";

export const MENU_IDS = [
  "add_storage_object_menu",
  "assistant_settings_menu",
  "attached_file_to_chat",
  "attached_html_to_spa",
  "case_object_fields",
  "case_feasibility_menu",
  "export_drawio_schema_menu",
  "import_drawio_schema_menu",
  "publish_version_menu",
  "sidebar_item_actions_menu",
  "sidebar_item_transfer_menu",
  "select_layout_menu",
] as const;

export const APP_MENUS: TAppMenus = createInitialEntities(
  MENU_IDS,
  (id: TMenuIds): TAppMenu => ({
    id,
    info: null,
    isOpen: false,
    position: null,
    subtype: "",
  }),
);
